module.exports = __webpack_public_path__ + "media/icons/firma-grey@2x-311bf755.png";